import React from 'react'

import { ProjectCreate } from 'modules/ProjectCreate/containers'
import { Layout } from 'components'

const ProjectCreatePage = () => (
  <Layout>
    <div className="sbx-row sbx-row-gutter-20">
      <div className="sbx-col-xs-22 sbx-col-offset-xs-1">
        <ProjectCreate />
      </div>
    </div>
  </Layout>
)

export default ProjectCreatePage
